// Permission keys matching backend format: {Module}.{Entity}.{Action}
// Standard actions: Create, Read, Edit, Delete

export const PERMISSIONS = {
  // PMS Module
  PMS_ABSTRACT_COMPONENTS_CREATE: 'PMS.AbstractComponents.Create',
  PMS_ABSTRACT_COMPONENTS_READ: 'PMS.AbstractComponents.Read',
  PMS_ABSTRACT_COMPONENTS_EDIT: 'PMS.AbstractComponents.Edit',
  PMS_ABSTRACT_COMPONENTS_DELETE: 'PMS.AbstractComponents.Delete',
  PMS_VESSEL_COMPONENTS_CREATE: 'PMS.VesselComponents.Create',
  PMS_VESSEL_COMPONENTS_READ: 'PMS.VesselComponents.Read',
  PMS_VESSEL_COMPONENTS_EDIT: 'PMS.VesselComponents.Edit',
  PMS_VESSEL_COMPONENTS_DELETE: 'PMS.VesselComponents.Delete',
  PMS_VESSEL_SPARES_CREATE: 'PMS.VesselSpares.Create',
  PMS_VESSEL_SPARES_READ: 'PMS.VesselSpares.Read',
  PMS_VESSEL_SPARES_EDIT: 'PMS.VesselSpares.Edit',
  PMS_VESSEL_SPARES_DELETE: 'PMS.VesselSpares.Delete',
  PMS_VESSEL_JOBS_CREATE: 'PMS.VesselJobs.Create',
  PMS_VESSEL_JOBS_READ: 'PMS.VesselJobs.Read',
  PMS_VESSEL_JOBS_EDIT: 'PMS.VesselJobs.Edit',
  PMS_VESSEL_JOBS_DELETE: 'PMS.VesselJobs.Delete',
  PMS_MEASUREMENT_UNITS_CREATE: 'PMS.MeasurementUnits.Create',
  PMS_MEASUREMENT_UNITS_READ: 'PMS.MeasurementUnits.Read',
  PMS_MEASUREMENT_UNITS_EDIT: 'PMS.MeasurementUnits.Edit',
  PMS_MEASUREMENT_UNITS_DELETE: 'PMS.MeasurementUnits.Delete',
  // Fleet Jobs
  PMS_FLEET_JOBS_CREATE: 'PMS.FleetJobs.Create',
  PMS_FLEET_JOBS_READ: 'PMS.FleetJobs.Read',
  PMS_FLEET_JOBS_EDIT: 'PMS.FleetJobs.Edit',
  PMS_FLEET_JOBS_DELETE: 'PMS.FleetJobs.Delete',
  // Vessel Job Instances (migrated from codes.ts — preserves existing backend string)
  PMS_VESSEL_JOB_INSTANCES_EDIT: 'PMS.VesselJobInstances.Edit',
  // Running Hours
  PMS_RUNNING_HOURS_CREATE: 'PMS.RunningHours.Create',
  PMS_RUNNING_HOURS_READ: 'PMS.RunningHours.Read',
  PMS_RUNNING_HOURS_EDIT: 'PMS.RunningHours.Edit',
  PMS_RUNNING_HOURS_DELETE: 'PMS.RunningHours.Delete',
  // Workflows
  PMS_WORKFLOWS_CREATE: 'PMS.Workflows.Create',
  PMS_WORKFLOWS_READ: 'PMS.Workflows.Read',
  PMS_WORKFLOWS_EDIT: 'PMS.Workflows.Edit',
  PMS_WORKFLOWS_DELETE: 'PMS.Workflows.Delete',
  PMS_WORKFLOWS_SUBMIT: 'PMS.Workflows.Submit',
  // Approvals
  PMS_APPROVALS_READ: 'PMS.Approvals.Read',
  PMS_APPROVALS_APPROVE: 'PMS.Approvals.Approve',
  PMS_APPROVALS_SUBMIT: 'PMS.Approvals.Submit',
  // HSQE SMS Folders — edit-class capability codes (ADR-0047), lowercase backend literals
  HSQE_SMS_FOLDER_CREATE: 'sms.folder.create',
  HSQE_SMS_FOLDER_RENAME: 'sms.folder.rename',
  HSQE_SMS_FOLDER_MOVE: 'sms.folder.move',
  HSQE_SMS_FOLDER_DELETE: 'sms.folder.delete',
  // HSQE SMS document external regulatory references (HSQE-73, ADR-0047 idiom)
  HSQE_SMS_DOCUMENT_MANAGE_EXTERNAL_REFS: 'sms.document.manage-external-refs',
  // HSQE SMS document authored cross-links (HSQE-72, Surface 1 / ADR-0071, ADR-0047 idiom)
  HSQE_SMS_DOCUMENT_MANAGE_CROSS_LINKS: 'sms.document.manage-cross-links',
  // HSQE SMS Master's Review lifecycle (HSQE-220/221/222). The Company-role gate
  // (mrCanWriteCompanyResponse) covers both the Company Response write and Re-open;
  // the DPA acknowledgement is separately gated (the design's canDo('mr.dpa_acknowledge')).
  HSQE_SMS_REVIEW_WRITE_COMPANY_RESPONSE: 'sms.masters-review.write-company-response',
  HSQE_SMS_REVIEW_REOPEN: 'sms.masters-review.reopen',
  HSQE_SMS_REVIEW_DPA_ACKNOWLEDGE: 'mr.dpa_acknowledge'
} as const;

export type PermissionKey = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
